import { render, staticRenderFns } from "./manageCollectionpoint.vue?vue&type=template&id=24acf840&scoped=true"
import script from "./manageCollectionpoint.vue?vue&type=script&lang=js"
export * from "./manageCollectionpoint.vue?vue&type=script&lang=js"
import style0 from "./manageCollectionpoint.vue?vue&type=style&index=0&id=24acf840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24acf840",
  null
  
)

export default component.exports